import { render, staticRenderFns } from "./service-worker-notifier.vue?vue&type=template&id=15304541&scoped=true&"
import script from "./service-worker-notifier.vue?vue&type=script&lang=ts&"
export * from "./service-worker-notifier.vue?vue&type=script&lang=ts&"
import style0 from "./service-worker-notifier.vue?vue&type=style&index=0&id=15304541&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15304541",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\VelipetteriLehto\\Projects\\Europress\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15304541')) {
      api.createRecord('15304541', component.options)
    } else {
      api.reload('15304541', component.options)
    }
    module.hot.accept("./service-worker-notifier.vue?vue&type=template&id=15304541&scoped=true&", function () {
      api.rerender('15304541', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/view/partial/service-worker-notifier.vue"
export default component.exports